export type CacheType = "TNVED" | "GTIN";

export interface ICacheRow {
  id: string;
  key: string;
  type: CacheType;
  displayValue: string;
  gtinLinkedValue: string | null;
  consumerName: string;
  searchText: string;
}

const TNVED_PREFIX = "tnved::";
const IGNORED_PREFIXES = ["shepCert::"];

const isGtinKey = (key: string): boolean => /^\d+$/.test(key);

export const buildConsumerMap = (data: unknown): Map<number, string> => {
  const map = new Map<number, string>();
  const list = Array.isArray(data)
    ? data
    : (data as { consumers?: Array<{ id: number; name: string }> })?.consumers ?? [];

  for (const item of list) {
    if (item?.id != null && item.name) {
      map.set(Number(item.id), String(item.name));
    }
  }

  return map;
};

const resolveConsumerName = (
  consumerId: number | null,
  consumerMap: Map<number, string>,
): string => {
  if (consumerId == null) return "-";
  return consumerMap.get(consumerId) ?? String(consumerId);
};

/** Парсинг объекта GET /operator/cache/all */
export const normalizeCacheResponse = (
  data: unknown,
  consumerMap: Map<number, string>,
): ICacheRow[] => {
  if (!data || typeof data !== "object" || Array.isArray(data)) return [];

  const obj = data as Record<string, unknown>;
  const rows: ICacheRow[] = [];

  for (const key of Object.keys(obj)) {
    if (IGNORED_PREFIXES.some((prefix) => key.startsWith(prefix))) continue;

    const rawValue = obj[key];

    if (key.startsWith(TNVED_PREFIX)) {
      const displayValue = key.slice(TNVED_PREFIX.length);
      let consumerId: number | null = null;

      if (rawValue && typeof rawValue === "object") {
        const pk = (rawValue as { tnvedPK?: { consumer?: number } }).tnvedPK;
        if (pk?.consumer != null) consumerId = Number(pk.consumer);
      }

      const consumerName = resolveConsumerName(consumerId, consumerMap);

      rows.push({
        id: key,
        key,
        type: "TNVED",
        displayValue,
        gtinLinkedValue: null,
        consumerName,
        searchText: `${displayValue} ${consumerName}`.toLowerCase(),
      });
      continue;
    }

    if (isGtinKey(key)) {
      const gtinLinkedValue = typeof rawValue === "string" ? rawValue : "";
      const consumerName = "-";

      rows.push({
        id: key,
        key,
        type: "GTIN",
        displayValue: key,
        gtinLinkedValue,
        consumerName,
        searchText: `${key} ${gtinLinkedValue}`.toLowerCase(),
      });
    }
  }

  return rows;
};

export const formatCacheValueCell = (row: ICacheRow): string => {
  if (row.type === "GTIN") {
    return `${row.displayValue}: "${row.gtinLinkedValue ?? ""}"`;
  }
  return row.displayValue;
};
